export default __webpack_public_path__ + "static/media/edit.66149cac.svg";